const project = localStorage.getItem('project')
  ? JSON.parse(localStorage.getItem('project'))
  : {};
export const state = {
  projects: [],
  project: project,
  modalProject: false,
  modalInvite: false,
  notExistsEmails: [],
  projectUsers: [],
};
